import React from "react";

const Benefits = () => {
  return (
    <div className="csd-benefits-wrapper">
      <h1>
        Benefits Of Soori's <span>Custom</span> Software Development
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Customized solutions tailored to your business</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Enhanced operational efficiency and automation</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Scalable for future business growth and demands</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Cost-effective development that aligns with your budget</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
